import React from "react";
import "./Header.css";

function Header() {
  const token = localStorage.getItem("token");

  const logout = () => {
    localStorage.removeItem("token");
    window.location.href = "/login";
  };

  return (
    <header className="header">
      <div className="logo">
        <img
          src={process.env.PUBLIC_URL + "/asbntv-logo.jpg"}
          alt="logo"
        />
      </div>

      <nav className="nav">
        <a href="/">Home</a>
        <a href="/category/politics">Politics</a>
        <a href="/category/sports">Sports</a>
        <a href="/category/tech">Tech</a>
        <a href="/category/world">World</a>

        {/* ✅ Show only when logged in */}
        {token && <a href="/admin">Dashboard</a>}
      </nav>

      <div className="right-space">
        {/* ✅ Right side login/logout */}
        {token ? (
          <button className="logout-btn" onClick={logout}>
            Logout
          </button>
        ) : (
          <a href="/login" className="login-link">
            Login
          </a>
        )}
      </div>
    </header>
  );
}

export default Header;